import { useEffect, useState } from "react";
import messages from "messages";
import { Button } from "react-bootstrap";
// components
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import { ReactComponent as MFAAllSet } from "assets/svg/mfa-all-set.svg";
// constants
import { SHOW_MFA_ALL_SET_MODAL } from "constants/showMFAAllSetModal";
// hooks
import { useUser } from "contexts/UserContext";
// styles
import styles from "./MFAAllSetModal.module.scss";

/**
 * renders a modal to notify user that the schedule has been created
 */
const MFAAllSetModal = () => {
  const { user } = useUser();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    if (
      window.localStorage.getItem(SHOW_MFA_ALL_SET_MODAL.key) ===
      SHOW_MFA_ALL_SET_MODAL.value
    ) {
      setShow(true);
    }
    window.localStorage.removeItem(SHOW_MFA_ALL_SET_MODAL.key);
  }, [user]);

  return (
    <ModalLayout
      size={"md"}
      show={show}
      onHide={() => setShow(false)}
      showHeaderDivider={false}
      dialogClassName={styles["mfa-set-modal__dialog"]}
      headerClass={styles["mfa-set-modal__header"]}
      bodyClass={styles["mfa-set-modal__body"]}
      footerClass={styles["mfa-set-modal__footer"]}
    >
      <MFAAllSet />
      <div className={styles["mfa-set-modal__title"]}>You're all set!</div>
      <p className={styles["mfa-set-modal__text"]}>
        Two-step verification is now enabled for your account. You'll need to
        use it every time you sign in.
      </p>
      <Button
        onClick={() => setShow(false)}
        className={styles["mfa-set-modal__btn"]}
      >
        {messages.gotIt}
      </Button>
    </ModalLayout>
  );
};

export default MFAAllSetModal;
